export default {
  pages: {
    warehouse: {
      title: 'Ombor',
      tabs: ['Oflayn', 'Moderatsiyada', 'Onlayn'],
      addManually: "Qo'lda qo'shish",
    },
  },
};
